function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : {};
}

const rgbToRgbaString = (rgb, opacity) =>
  `rgba(${rgb.r},${rgb.g}, ${rgb.b}, ${opacity})`;

export const hexToRgba = (hex, opacity = 1) =>
  rgbToRgbaString(hexToRgb(hex), opacity);
